import { createRouter, createWebHistory } from "vue-router";
import EnVersion from "../views/EnVersion.vue";

const routes = [
  {
    path: "/",
    redirect: "/EnVersion",
  },
  {
    path: "/EnVersion",
    name: "EnVersion",
    component: EnVersion,
  },
  {
    path: "/FrVersion",
    name: "FrVersion",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/FrVersion.vue"),
  },
  {
    path: "/AbVersion",
    name: "AbVersion",
    component: () => import("../views/AbVersion.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
